<template>
  <div class="c-folder-layer__item d-flex align-items-center mt-2">
    <div class="c-folder-layer__item--preview mr-2">
      <img
        class="layer--item__img"
        :src="src"
        :alt="name"
      >
    </div>
    <div
      ref="tooltip"
      class="layer--item__text"
    >
      <b-tooltip
        :show.sync="isTooltipShown"
        :target="() => $refs.tooltip"
        triggers="hover"
        boundary="viewport"
        noninteractive
        :disabled="isNotTruncated(name)"
      >
        {{ name }}
      </b-tooltip>
      <EditableTextElement
        :default-value="name"
        :render-value="truncateFieldName"
      />
    </div>
  </div>
</template>

<script>
import EditableTextElement from '@frontend/components/common/atoms/EditableTextElement.vue';
import layerMixin from './mixin';

export default {
  name: "ImageLayer",
  components: {
    EditableTextElement,
  },
  mixins: [layerMixin],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    src() {
      return location.origin + '/share?file=' + (this.node.data.image) + '&lightweight&scale=128'
    },
  },
}
</script>


<style scoped lang="scss">

</style>
